import { motion } from "framer-motion";
import { Globe, Shield, Users, Landmark } from "lucide-react";

const highlights = [
  {
    icon: Users,
    title: "Verified Members",
    description: "Vetted businesses and professionals across trade and investment sectors in Africa, Asia and the Middle East.",
  },
  {
    icon: Shield,
    title: "Verified Businesses",
    description: "Every member undergoes verification to ensure trusted trade partnerships and credibility.",
  },
  {
    icon: Globe,
    title: "Trade & Investment Network",
    description: "Access trade and investment opportunities across Africa, Asia and the Middle East.",
  },
  {
    icon: Landmark,
    title: "Chamber Backed",
    description: "Supported by the AAMECC with government liaison, policy advocacy, and trade facilitation.",
  },
];

const TrustSection = () => {
  return (
    <section className="py-12 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center border border-border bg-card rounded-lg p-6 hover:border-gold/30 transition-colors"
            >
              <div className="w-12 h-12 mx-auto mb-4 bg-navy rounded-lg flex items-center justify-center">
                <item.icon className="w-6 h-6 text-gold" />
              </div>
              <h3 className="text-base font-semibold text-foreground mb-2">{item.title}</h3>
              <p className="text-xs text-black/80 leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
